import { render } from "./CategoryCourses.vue?vue&type=template&id=36f456e0&scoped=true"
import script from "./CategoryCourses.vue?vue&type=script&lang=js"
export * from "./CategoryCourses.vue?vue&type=script&lang=js"

import "./CategoryCourses.vue?vue&type=style&index=0&id=36f456e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f456e0"]])

export default __exports__